@if (vm$ | async; as vm) {
  <!-- controls, visible for over mode only -->
  @if (vm.showControls) {
    <div id="global-side-nav-controls">
      <nv-icon-button
        name="hamburger-large-blue"
        [ariaLabelData]="{
          iconButtonAriaLabel: 'Toggle menu',
        }"
        (clickButton)="onBurgerClick()"
      ></nv-icon-button>

      <nv-logo (logoClick)="onLogoClick()" type="portal" [pointerOnHover]="true"></nv-logo>
    </div>
  }

  <!-- nav items -->
  <div
    id="global-side-nav-items"
    [ngClass]="[
      'global-side-nav-content__mode-' + vm.sideNav.matSideNavMode,
      'global-side-nav-content__state-' + vm.sideNav.sideNavState,
    ]"
  >
    @if (vm.showCollapsed) {
      @for (section of vm.squareNavSections; track $index) {
        <div class="bucket-list">
          @for (entry of section; track entry.item.key) {
            <div
              cdkOverlayOrigin
              #parentOverlayOrigin="cdkOverlayOrigin"
              class="collapsed-parent-item"
              (mouseenter)="onCollapsedParentMouseEnter(entry.item, parentOverlayOrigin)"
              (mouseleave)="onCollapsedParentMouseLeave()"
              (focusin)="onCollapsedParentFocusIn(entry.item, parentOverlayOrigin)"
              (focusout)="onCollapsedParentFocusOut($event)"
            >
              <nv-square-button
                (clickButton)="trackNavItemClick(entry.activeItem.key)"
                [active]="entry.isSelected || isOverlayActiveForItem(entry.item)"
                [icon]="entry.icon"
                [queryParams]="entry.activeItem.queryParams"
                [selected]="entry.isSelected"
                [text]="entry.item.human"
                [url]="entry.activeItem.url"
                [roundedCorner]="true"
              ></nv-square-button>
            </div>
          }
        </div>
      }

      <!-- Keep the flyout as a one time use case, but consider abstraction if needed -->
      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="activeOverlayOrigin"
        [cdkConnectedOverlayOpen]="!!activeOverlayParentItem"
        [cdkConnectedOverlayPositions]="overlayPositions"
        [cdkConnectedOverlayPanelClass]="overlayPanelClassName"
        [cdkConnectedOverlayPush]="true"
        [cdkConnectedOverlayHasBackdrop]="false"
        (detach)="hideOverlay()"
      >
        <div
          class="global-side-nav-collapsed-children-overlay"
          animate.enter="flyout-enter"
          role="navigation"
          [attr.aria-label]="(activeOverlayParentItem?.human || 'Child') + ' sub navigation'"
          (mouseenter)="onOverlayMouseEnter()"
          (mouseleave)="onOverlayMouseLeave()"
        >
          <nv-sidebar-list
            class="global-side-nav-collapsed-children-overlay-list"
            [listData]="activeOverlayParentItem?.children || []"
            [selectedKey]="selectedSidebarKey"
            [smallIcons]="true"
            (sidebarListItemSelect)="onOverlayChildSelect($event)"
          ></nv-sidebar-list>
        </div>
      </ng-template>
    }

    @if (vm.showExpandedOrOverOpened) {
      @for (section of vm.navSections; track $index) {
        <nv-sidebar-list
          class="bucket-list"
          [listData]="section"
          [selectedKey]="selectedSidebarKey"
          [smallIcons]="true"
          (sidebarListItemSelect)="trackNavItemClick($event)"
        ></nv-sidebar-list>
      }
    }
  </div>
} @else {
  <!-- global side nav skeleton: fixed count of items since the actual navigation data is not yet available.
       Collapsed only for now, so the state class is fixed rather than read from the nav config.
       Each placeholder occupies the same box as the nv-square-button it stands in for, so the two
       swap without moving anything. -->
  <div id="global-side-nav-items" class="global-side-nav-content__state-side-collapsed">
    @for (bucket of skeletonCollapsedBuckets; track $index) {
      <div class="bucket-list">
        @for (item of bucket; track item) {
          <div class="collapsed-parent-item">
            <div class="global-side-nav-skeleton-item" aria-hidden="true">
              <ngx-skeleton-loader [theme]="skeletonSideNavCollapsedIcon"></ngx-skeleton-loader>
              <ngx-skeleton-loader [theme]="skeletonSideNavCollapsedLabel"></ngx-skeleton-loader>
            </div>
          </div>
        }
      </div>
    }
  </div>
}
